import React from "react";
import { Line } from "react-chartjs-2";

import * as colors from "../../../assets/_base/colors";

const dataset = {
  data: [],
  fill: true,
  backgroundColor: colors.lightBlue,
  borderColor: colors.lightBlue,
  tension: 0.5,
  pointStyle: "rectRounded",
  pointRadius: 4,
  pointHoverRadius: 8,
  pointHoverBackgroundColor: colors.darkBlue,
  pointHoverBorderColor: colors.yellow,
  pointHoverBorderWidth: 2,
};

const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += `dia ${context.label} R$ ${context.parsed.y},00`;
            }
            return label;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    hover: {
      mode: "index",
      intersect: false,
    },
    elements: {
      line: {
        borderWidth: 3,
        fill: false,
      },
      point: {
        radius: 4,
        borderWidth: 2,
        hoverRadius: 7,
        hoverBorderWidth: 3,
      },
    },
  };

const LineChart = (props) => <Line data={props.data} options={options} ref={props.ref} />;


export default LineChart;

export {
    dataset
}


// WEBPACK FOOTER //
// ./src/_components/Chart/Line/index.jsx